import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Sparkles, LogIn } from "lucide-react";
import { LOGO_URL } from "@/lib/api";

const LINKS = [
  { to: "/galleria", label: "Galleria" },
  { to: "/assaggi-darte", label: "Assaggi d'Arte" },
  { to: "/assaggi-arte-salento", label: "Salento" },
  { to: "/wilder", label: "Wilder" },
  { to: "/ricette", label: "Ricette" },
  { to: "/shop", label: "Shop" },
  { to: "/corsi", label: "Corsi" },
  { to: "/servizi", label: "Servizi" },
  { to: "/blog", label: "Blog" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/contatti", label: "Contatti" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0A0A0A]/80 border-b border-[#2A2A2A]">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 flex items-center justify-between h-16">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2.5 font-display text-xl sm:text-2xl font-black tracking-tight">
          <img src={LOGO_URL} alt="Wilder'Squad" className="w-9 h-9 rounded-full object-cover" />
          WILDER<span className="text-[#E4BD44]">SQUAD</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-4" data-testid="desktop-nav">
          {LINKS.slice(0, 9).map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.slice(1)}`}
              className={({ isActive }) =>
                `ws-link text-sm font-medium tracking-wide ${isActive ? "text-[#E4BD44]" : "text-[#FCFCFC]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/wilder" data-testid="header-cta-wilder" className="btn-primary !py-2.5 !px-5 text-xs">
            <Sparkles size={14} /> Parla con Wilder
          </Link>
          <Link to="/admin" data-testid="header-login-btn"
            className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider border border-[#c4704b] text-[#c4704b] hover:bg-[#c4704b] hover:text-[#F9F6F0] px-4 py-2.5 transition-colors">
            <LogIn size={13} /> Accedi
          </Link>
        </nav>
        <div className="lg:hidden flex items-center gap-1">
          <Link to="/admin" data-testid="mobile-header-login-btn" aria-label="Accedi"
            className="p-2 text-[#c4704b]">
            <LogIn size={20} />
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            className="p-2"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-[#2A2A2A] bg-[#0A0A0A] px-5 py-5 flex flex-col gap-3.5 max-h-[calc(100vh-4rem)] overflow-y-auto" data-testid="mobile-nav">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="font-display text-xl py-1"
              data-testid={`mobile-nav-${l.to.slice(1)}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/wilder" onClick={() => setOpen(false)} className="btn-primary justify-center mt-2" data-testid="mobile-cta-wilder">
            <Sparkles size={14} /> Parla con Wilder
          </Link>
          <Link to="/admin" onClick={() => setOpen(false)} data-testid="mobile-nav-login"
            className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wider border border-[#c4704b] text-[#c4704b] hover:bg-[#c4704b] hover:text-[#F9F6F0] py-3 transition-colors">
            <LogIn size={15} /> Accedi
          </Link>
        </nav>
      )}
    </header>
  );
}
